import { Box, styled } from "@mui/material";
import { Link,useLocation } from "react-router-dom";

const VariantContainer = styled(Box)(({ theme }) => ({
  textDecoration: "none",
  
  width: "62px",
  maxWidth: "62px",
  height: "62px",
  outline:'none'
}));

const VariantBox = (props) => {
    const location = useLocation()
    const isActive = location.pathname === props?.url
    const border = isActive ? {border :"2px solid #F95799",borderRadius:"10px"} : {}
  return (
    <>
      <VariantContainer component={Link} to={props?.url} sx={border}>
        <img
          src={props.imgurl}
          style={{
            width: "62px",
            maxWidth: "62px",
            height: "62px",
            borderRadius: "10px",
          }}
          alt={props?.variant_name}
        />
      </VariantContainer>
    </>
  );
};

export default VariantBox;
